function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n\n  th {\n    font-weight: bold;\n  }\n\n  td,\n  th {\n    vertical-align: middle;\n    padding: 0 24px;\n    width: 10%;\n    min-width: 120px;\n  }\n\n  tr {\n    border-bottom: 1px solid #d3d7dc;\n    height: 56px;\n  }\n  thead {\n    border-bottom: 2px solid #d3d7dc;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n\n  ",
        "\n\n  ",
        " {\n    flex: 0 0 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n\n  ",
        "\n\n  th,\n  td {\n    &.dragOver {\n      border: 1px dashed ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  background: #f8f8fa;\n  height: 64px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  background: #fff;\n  color: #a0a9b4;\n  height: 56px;\n\n  ",
        " {\n    th:nth-child(2) {\n      background: rgba(211, 215, 220, 0.2);\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  background: #d3d7dc;\n  width: 40px;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 0;\n  transition: all 150ms;\n  font-size: 2em;\n\n  & + & {\n    margin-left: 6px;\n  }\n\n  &:hover {\n    background-color: #eee;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  cursor: move;\n\n  ",
        "\n\n  div.cell-buttons {\n    display: none;\n  }\n\n  &:hover {\n    div.cell-buttons {\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
import styled from "styled-components";
export var Table = styled.table(_templateObject());
export var LeftTable = styled(Table)(_templateObject1(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.phases) === null || ref === void 0 ? void 0 : ref.leftTable;
});
export var TwoTableLayoutContainer = styled.div(_templateObject2(), function(param) {
    var hasCustomComponents = param.hasCustomComponents;
    return hasCustomComponents && "\n  overflow: auto;\n  ";
}, LeftTable);
export var RightTableContainer = styled.div(_templateObject3(), function(param) {
    var hasCustomComponents = param.hasCustomComponents;
    return !hasCustomComponents && "\n    overflow: auto;\n  ";
}, function(param) {
    var theme = param.theme;
    return theme.palette.primary;
});
export var NumbersTr = styled.tr(_templateObject4());
export var LabelsTr = styled.tr(_templateObject5(), NumbersTr);
export var IconButton = styled.button(_templateObject6());
export var StyledCell = styled.th(_templateObject7(), function(param) {
    var dragOver = param.dragOver, theme = param.theme;
    return dragOver && "\n   border: 1px dashed ".concat(theme.palette.primary, "; \n   ");
});
export var CellButtons = styled.div(_templateObject8());
export var ConfirmationText = styled.div(_templateObject9());
